"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IncrementDecrement = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
// Modules
// Styled
const flora_react_icons_1 = require("@grupoboticario/flora-react-icons");
const Styled_1 = require("./Styled");
function IncrementDecrement(props) {
    const testId = `${props.testId}-IncrementDecrement`;
    const getValue = () => {
        if (props.value && props.value < 10) {
            return `0${props.value}`;
        }
        return props.value.toString();
    };
    const value = getValue();
    const onClickRemoveIcon = props.disableDecrement || !props.value ? () => { } : props.decrement;
    return ((0, jsx_runtime_1.jsxs)(Styled_1.Wrapper, Object.assign({ "data-testid": testId, className: testId }, { children: [(0, jsx_runtime_1.jsx)(Styled_1.IncrementDecrementWrapper, Object.assign({ type: "decrement", disable: props.disableDecrement || props.value === 0, "aria-label": "remover um produto", role: "button", onClick: onClickRemoveIcon }, { children: (0, jsx_runtime_1.jsx)(flora_react_icons_1.MinusIcon, { size: 20, "data-testid": `${testId}-remove-icon` }) })), (0, jsx_runtime_1.jsx)(Styled_1.Counter, Object.assign({ "data-testid": `${testId}-total` }, { children: value })), (0, jsx_runtime_1.jsx)(Styled_1.IncrementDecrementWrapper, Object.assign({ type: "increment", "aria-label": "adicionar um produto", role: "button", onClick: props.increment }, { children: (0, jsx_runtime_1.jsx)(flora_react_icons_1.PlusIcon, { size: 20, "data-testid": `${testId}-add-icon` }) }))] })));
}
exports.IncrementDecrement = IncrementDecrement;
